import React, { FC } from 'react';
import {
  CandidateLayout,
  DEFAULT_OG_IMAGES,
  SEO_COMMON,
} from '../../layout/candidate/CandidateLayout';
import { SubscriptionTable } from '../../components/SubscriptionModel/SubscriptionTable';
import styles from './subscription.module.less';
import { NextSeo } from 'next-seo';
import { SubscriptionMobileView } from '../../components/SubscriptionModel/SubscriptionMobileView';
import { Grid } from 'antd';

const FooterSubscription: FC = () => {
  const bp = Grid.useBreakpoint();
  return (
    <CandidateLayout
      title={
        <NextSeo
          canonical="https://www.careers360.lk/pricing"
          title="Job Sites in Sri Lanka | Pricing for Job Advertisements"
          description="Explore Careers360 job site for cost-effective pricing on job advertisements in Sri Lanka. Elevate your recruitment strategy & start hiring now to find best talent."
          additionalMetaTags={[
            {
              name: 'keywords',
              content:
                'Job sites in Sri Lanka, Job advertisements , Sri Lankan job sites , Sri Lanka job websites , Job vacancies advertisement ',
            },
          ]}
          openGraph={{
            title: `Job Sites in Sri Lanka | Pricing for Job Advertisements`,
            description:
              'Explore Careers360 job site for cost-effective pricing on job advertisements in Sri Lanka. Elevate your recruitment strategy & start hiring now to find best talent.',
            images: DEFAULT_OG_IMAGES,
          }}
          {...SEO_COMMON}
        />
      }>
      <div className={styles.container}>
        {bp.md ? (
          <div>
            <SubscriptionTable hideSubscribe={true} />
          </div>
        ) : (
          <div>
            <SubscriptionMobileView hideSubscribe={true} />
          </div>
        )}
      </div>
    </CandidateLayout>
  );
};
export default FooterSubscription;
